import React from 'react';
import { Typography, styled } from '@mui/material';

const Badge = styled('div')(({ theme }) => ({
  padding: '4px 8px',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.grey[200],
  '&.scheduled, &.open': {
    backgroundColor: theme.palette.info.main,
    color: theme.palette.info.contrastText,
  },
  '&.completed, &.closed': {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.success.contrastText,
  },
  '&.no_show': {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.warning.contrastText,
  },
  '&.deleted': {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
  },
}));

type StatusBadgeProps = {
  status: string;
  label: string;
};

// Status de guias (scheduled, completed, no_show, deleted) e de cirurgias (open, closed, deleted).
const StatusBadge: React.FC<StatusBadgeProps> = ({ status, label }) => (
  <Badge className={status}>
    <Typography variant="body2" fontWeight={600} color="inherit" noWrap>
      {label}
    </Typography>
  </Badge>
);

export default StatusBadge;
